import { Component, OnInit } from '@angular/core';
import { FileListComponent } from '@app/shared/components/file-upload/file-list.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
  selector: 'file-operation-list',
  templateUrl: './file-operation-list.component.html',
  styleUrls: ['./file-operation-list.component.scss']
})
export class FileOperationListComponent extends FileListComponent implements OnInit {

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
    this._idPrefix = 'file_operation_list.';
  }

  public ngOnInit() {
    super.ngOnInit();
  }

}
